import React, { memo } from 'react';
import { FlexView } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import { ChevronLeft } from '@styled-icons/material/ChevronLeft';
import { ChevronRight } from '@styled-icons/material/ChevronRight';
import Humanize from 'humanize-plus';
import COLORS from 'constants/colors';
import ChunkThumbnail from '../chunk-thumbnail';
import {
  ChunkNavContainer,
  TopRow,
  ThumbnailsRow,
  NavButtons,
  PageIndicator,
  NavButton,
} from './chunk-nav-styled';

const ChunkNav = ({
  eventIndex,
  chunks,
  activeChunkIndex,
  onSelectChunk,
  onPrev,
  onNext,
}) => {
  const totalChunks = chunks?.length || 0;

  if (!totalChunks) return null;

  return (
    <ChunkNavContainer>
      <TopRow flexDirection="row" alignItems="center">
        <FlexView flexDirection="row" alignItems="baseline" style={{ gap: 6 }}>
          <Text variant="cta2" color={COLORS.COLA}>Event {eventIndex + 1}</Text>
          <Text variant="body2" color={COLORS.BLACK_T_60}>
            {Humanize.pluralize(totalChunks, 'chunk')}
          </Text>
        </FlexView>
        {totalChunks > 1 && (
          <NavButtons flexDirection="row" alignItems="center">
            <NavButton disabled={activeChunkIndex === 0} onClick={onPrev}>
              <ChevronLeft size={18} color={COLORS.WHITE} />
            </NavButton>
            <PageIndicator>
              <Text variant="body3" color={COLORS.COLA_LIGHT} align="center">
                {activeChunkIndex + 1}/{totalChunks}
              </Text>
            </PageIndicator>
            <NavButton disabled={activeChunkIndex === totalChunks - 1} onClick={onNext}>
              <ChevronRight size={18} color={COLORS.WHITE} />
            </NavButton>
          </NavButtons>
        )}
      </TopRow>
      <ThumbnailsRow flexDirection="row" alignItems="center">
        {chunks.map((chunk, idx) => (
          <ChunkThumbnail
            key={chunk.chunk_index}
            chunk={chunk}
            index={idx}
            isActive={idx === activeChunkIndex}
            onSelect={onSelectChunk}
          />
        ))}
      </ThumbnailsRow>
    </ChunkNavContainer>
  );
};

export default memo(ChunkNav);
